import React, { useState, useEffect } from 'react';
import classes from './VideoCarousel.module.css';

const TRANSITION_DURATION = 1000; // длительность перехода в мс
const DISPLAY_DURATION = 4500; // общее время показа одного видео

const VideoCarousel: React.FC = () => {
    const videos = ['/hotel-products/hotel-3.mp4', '/hotel-products/hotel-4.mp4', '/hotel-products/hotel-5.mp4', '/hotel-products/hotel-6.mp4'];

    const [activeIndex, setActiveIndex] = useState(0);
    const [prevIndex, setPrevIndex] = useState<number | null>(null);
    const [activeOpacity, setActiveOpacity] = useState(0);
    const [prevOpacity, setPrevOpacity] = useState(1);

    // таймер для переключения слайда
    useEffect(() => {
        const timer = setTimeout(() => {
            setPrevIndex(activeIndex);
            setPrevOpacity(1);
            setActiveIndex((prev) => (prev + 1) % videos.length);
            setActiveOpacity(0);
        }, DISPLAY_DURATION);
        return () => clearTimeout(timer);
    }, [activeIndex, videos.length]);

    // анимация появления и исчезания
    useEffect(() => {
        requestAnimationFrame(() => {
            setActiveOpacity(1);
            if (prevIndex !== null) {
                setPrevOpacity(0);
            }
        });
        if (prevIndex !== null) {
            const timer = setTimeout(() => {
                setPrevIndex(null);
            }, TRANSITION_DURATION);
            return () => clearTimeout(timer);
        }
    }, [activeIndex, prevIndex]);

    return (
        <div className={classes.videoCarouselContainer}>
            {prevIndex !== null && (
                <video
                    key={prevIndex}
                    className={classes.videoCarouselItem}
                    src={videos[prevIndex]}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                        opacity: prevOpacity,
                        transition: `opacity ${TRANSITION_DURATION}ms ease`,
                    }}
                />
            )}
            <video
                key={activeIndex}
                className={classes.videoCarouselItem}
                src={videos[activeIndex]}
                autoPlay
                loop
                muted
                playsInline
                style={{
                    opacity: activeOpacity,
                    transition: `opacity ${TRANSITION_DURATION}ms ease`,
                }}
            />
        </div>
    );
};

export default VideoCarousel;
